import api from './api';
import {
  SentimentSummary,
  SentimentTrendsResponse,
  TopicDistributionResponse,
  TopicInsightsResponse,
  QualityOverviewResponse,
  CompareProvidersResponse,
  DashboardMetrics,
  RefreshMetricsResponse,
  AlertsResponse,
  JobStatusResponse,
  TopicSortBy,
} from '../types/analytics';

// Analytics Service
export const analyticsService = {
  getSentimentSummary: async (providerId: number): Promise<SentimentSummary> => {
    const response = await api.get(`/api/analytics/provider/${providerId}/sentiment/summary`);
    return response.data;
  },

  getSentimentTrends: async (
    providerId: number,
    period: string = 'daily',
    days: number = 30
  ): Promise<SentimentTrendsResponse> => {
    const response = await api.get(`/api/analytics/provider/${providerId}/sentiment/trends`, {
      params: { period, days },
    });
    return response.data;
  },

  getTopicDistribution: async (
    providerId: number,
    sortBy: TopicSortBy = 'frequency'
  ): Promise<TopicDistributionResponse> => {
    const response = await api.get(`/api/analytics/provider/${providerId}/topics/distribution`, {
      params: { sort_by: sortBy },
    });
    return response.data;
  },

  getTopicInsights: async (providerId: number): Promise<TopicInsightsResponse> => {
    const response = await api.get(`/api/analytics/provider/${providerId}/topics/insights`);
    return response.data;
  },

  getQualityOverview: async (providerId: number): Promise<QualityOverviewResponse> => {
    const response = await api.get(`/api/analytics/provider/${providerId}/quality/overview`);
    return response.data;
  },

  compareProviders: async (providerIds: number[]): Promise<CompareProvidersResponse> => {
    const response = await api.get('/api/analytics/compare', {
      params: { provider_ids: providerIds.join(',') },
    });
    return response.data;
  },
};

// Dashboard Service
export const dashboardService = {
  getMetrics: async (providerId: number): Promise<DashboardMetrics> => {
    const response = await api.get(`/api/dashboard/provider/${providerId}/metrics`);
    return response.data;
  },

  refreshMetrics: async (providerId: number): Promise<DashboardMetrics> => {
    const response = await api.post<RefreshMetricsResponse>(
      `/api/dashboard/provider/${providerId}/refresh`
    );
    return response.data.metrics;
  },

  getAlerts: async (
    providerId: number,
    days: number = 7,
    severity?: string
  ): Promise<AlertsResponse> => {
    const response = await api.get(`/api/dashboard/provider/${providerId}/alerts`, {
      params: { days, severity: severity || undefined },
    });
    return response.data;
  },

  acknowledgeAlert: async (alertId: string): Promise<void> => {
    await api.post(`/api/dashboard/alerts/${alertId}/acknowledge`);
  },

  getJobStatus: async (): Promise<JobStatusResponse> => {
    const response = await api.get('/api/dashboard/jobs/status');
    return response.data;
  },
};
